import cheRequest from '@/utils/cheRequest';
var cheApi = {
  getDriverInfo: function getDriverInfo(brandNumber) {
    return cheRequest({
      url: "api/realDrivers?brandnumber=".concat(brandNumber),
      method: 'get'
    });
  }
};
export default cheApi;